import { useMutation, useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'constants/endpoints';
import { get, handleError, handleResponse, post, del } from './base.service';

export const useGetAdvertisementQuery = (data: any) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(
					`${API_ENDPOINTS.GET_ADVERTISEMENT}?advertisementType=${data?.activeKey}&${data?.paramsQuery}`,
				);
				return handleResponse(response);
			} catch (err: any) {
				handleError(err);
			}
		},
		queryKey: ['get-advertisement'],
		enabled: !!data?.activeKey,
		refetchOnWindowFocus: false,
	});

export const useGetAdvertisementPriceQuery = () =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.ADVERTISEMENT_PRICE}`);
				return handleResponse(response);
			} catch (err: any) {
				handleError(err);
			}
		},
		queryKey: ['get-price'],
	});

export const useAddAdvertisementMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.ADVERTISEMENT, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useCancelAdvertisementMutation = () =>
	useMutation({
		mutationFn: (params: number | null = null) => {
			return del(`${API_ENDPOINTS.ADVERTISEMENT}/${params}`);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});
